import { useIsBelowMd } from 'hooks/use-is-below-md';
import { DataGridLightCardMode } from '../models';

/**
 * The card-mode switch (Phase F1, D-10 / D-53; N2b, PD-10): true below `md`
 * unless the grid opted out (`cardMode={false}`). A grid without the prop
 * card-renders with the automatic anatomy; every grid keeps its table at and
 * above `md`. The edge is the theme's (rules/responsive.md).
 */
export const useDataGridLightCardMode = (
  cardMode: DataGridLightCardMode | false | undefined,
): boolean => {
  const isBelowMd = useIsBelowMd();
  return cardMode !== false && isBelowMd;
};
